<template>
  <div id="app">
    <router-view class="rview"/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  props: {},
  data () { return {} },
  components: {
    'lsr-header': Header,
    'lsr-footer': Footer
  }
}
</script>


<style lang="scss">
@import "./assets/styles/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap');

body {
  background-color: $paho-background;
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  Font-family: "Roboto",sans-serif;
  // text-align: center;
  // color: #2c3e50;
  a {
    color: $episte-color;
  }
}

.rview {
  min-height: 80vh;
}
</style>

